import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function DefinicionDeLineas() {
  return (
    <ClipperPlaceholder title="Definición de Líneas" category="Operativas" />
  );
}
